import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
      <p style={{ fontSize: '4rem', fontWeight: 700, color: 'var(--color-accent)', lineHeight: 1 }}>
        404
      </p>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, margin: '1rem 0 0.5rem' }}>
        Page not found
      </h1>
      <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginBottom: '1.5rem' }}>
        The page you are looking for does not exist or has been moved.
      </p>
      <Link to="/podcasts" className="btn btn--primary">
        Back to podcasts
      </Link>
    </div>
  );
}
